export enum ApplicationType {
  MAIN = 'Main',
  SUPPLEMENTARY = 'Supplement',
}
